import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import styles from './style/icon-button.module.less';
import cs from 'classnames';

function IconButton(props, ref) {
  const {
    icon,
    className,
    ...rest
  } = props;
  return /*#__PURE__*/React.createElement(_Button, _extends({
    size: "mini",
    iconOnly: true,
    ref: ref,
    icon: icon // shape="circle"
    ,
    type: "text",
    className: cs(styles['icon-button'], className)
  }, rest));
}

export default /*#__PURE__*/forwardRef(IconButton);